module.exports = __webpack_public_path__ + "static/media/sabrina-max.d6acdcbc.wav";